import { SimpleVariable } from "../variableTypes/SimpleVariable";
import {
  ComplexVariableType,
  VariableDataType,
} from "../variableTypes/VariableType";

export class FilterRepeatVariables {
  public static Filter(variable: SimpleVariable): boolean {
    if (
      variable.complexVarType == ComplexVariableType.Complex &&
      variable.variableDataType == VariableDataType.Object
    ) {
      return true;
    }
    return false;
  }
}
